import { AxiosResponse } from 'axios'
import { AxiosAuthRefreshRequestConfig } from 'axios-auth-refresh'
import * as z from 'zod'

import { ApiModel } from './core'

const schema = z.object({})

export type AuthCodeChannel = 'email' | 'sms'

export type AuthCodeResponse = {
  status: boolean
  message: string
  channel: AuthCodeChannel
  maskedEmail: string | null
}

export class Auth extends ApiModel<typeof schema> {
  static jsonApiType = 'auth'

  static schema = schema

  static async code(phone: string, channel?: 'sms') {
    const url = `${this.getJsonApiUrl()}/code`
    const client = this.httpClient.getImplementingClient()

    return client
      .post<
        { phone: string; channel?: 'sms' },
        AxiosResponse<AuthCodeResponse>
      >(url, { phone, channel }, {
        skipAuthRefresh: true,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
      } as AxiosAuthRefreshRequestConfig)
      .then(({ data }) => data)
  }
}
